/// <reference path="./d/app.d.ts" />
/// <reference path="sxcframe.ts" />

declare var SystemJS : any;

module Sxc.Event
{
	interface Event
	{
		event : string;
		handler : Function;
		repeatable : boolean;
	}

	export class Handler
	{
		_events : Event[] = [];

		on(event : any, handler : Function)
		{
			// debug.log(this.TAG, "on", event, this._events.slice());

			if (event instanceof Array) {
				for (let i = 0; i < event.length; i++) {
					this.on(event[i], handler);
				}
			} else {
				this._events.push({
					event : <string> event,
					handler : handler,
					repeatable : true
				});
			}
		}

		trigger(event : string, ...params)
		{
			// debug.log(this.TAG, "trigger", event, params, this._events.slice());

			for(var i = this._events.length - 1; i>=0; i--)
			{
				var evt = this._events[i];
				if (evt.event === event) {
					evt.handler.apply(params);
					if (!evt.repeatable) {
						this._events.splice(i, 1);
					}
				}
			}
		}

		one(event : string, handler : Function = null)
		{
			this._events.push({
				event : event,
				handler : handler,
				repeatable : false
			});
			// debug.log(this.TAG, "one", event, this._events.slice());
		}

		off(event : string, handler : Function = null)
		{
			// debug.log("event.off", event);
			for(let i=this._events.length - 1; i>=0; i--)
			{
				if (this._events[i].event === event) {
					if (!handler || this._events[i].handler == handler) {
						this._events.splice(i, 1);
					}
				}
			}
		}
	}
}

interface SecurionPayChatNotificationEventParams {
	success ?: boolean;
	type ?: "autopay" | "generic";
}

interface SecurionPayChatEventHandler
{
	showNotification(message : string, params : SecurionPayChatNotificationEventParams) : void,
	promoUpdated(promo : any) : void;
	setCurrentPromo(promo : any) : void;
	updatePushPromo(data : any) : void;
}

interface SecurionPayChatHandler
{
	register(eventHandler : SecurionPayChatEventHandler) : void;

	unRegister() : void;

	doQuickBuy(amount : number,
	           special : any,
	           onReady : (success : boolean, data : any) => void) : void;

	doPurchase(amount : number,
	           name : string,
	           email : string,
	           card : string,
	           expYear : string,
	           expMonth : string,
	           cvc : string,
	           store : boolean,
	           autoPay : boolean,
	           onReady : (success : boolean, data : any) => void) : void;

	showAltPaymentButtonOnInit() : void;

}

const roomPreview =
{
	initialized: false,
	enabled: true,

	redirectTimer: null,
	supported: null,
	params: null,
	currentRoom: null,

	redirectTimeout: 60000,

	roomPreview : null,

	init(params)
	{
		if (this.initialized) {
			console.error("Roompreview initialized twice. Ignoring");
			return;
		}

		debug.log("[RoomPreview::init]", {params:params});

		const roomlistContainer = $(".roomlist-container");
		const that = this;

		this.params = params || {};
		// @ts-ignore
		this.supported = "Hls" in window && window["Hls"].isSupported();

		if (this.supported)
		{
			// Add event handlers
			roomlistContainer.on("mouseenter", ".roomlist_room .roomlist_border", function(e) {
				that.show($(this).parent(".roomlist_room"));
			});

			roomlistContainer.on("mouseleave", ".roomlist_room .roomlist_border", function(e) {
				that.hide();
			});

		} else {
			debug.log("[RoomPreview::init]", "Flash is not installed, or too old. Chatpreview will not work.");
		}

		this.initialized = true;
	},

	show: function($room) {

		this.hide();
		if (!this.initialized || !this.enabled || !this.supported) return;

		window["roomList"].disableAjax();

		const perfid = $room.data("perfid");
		const onlineState = $room.data("onlinestate");
		const hlsActive = $room.data("hlsactive");
		const id = "roomPreview" + $room.data("perfid");
		const $cnt = $room.find(".flash-container");

		// Add placeholder div to be replaced with the flash obj.
		$cnt.append($("<div />").attr("id", id));

		this.currentRoom = {
			"perfid": perfid,
			"container": $cnt,
			"url": $room.data("showurl")
		};

		if (hlsActive == "0" || onlineState == "offline" || onlineState == "vip" || onlineState == "private") {
			this.showStatus($cnt, perfid, onlineState);
		} else {
			this.showPreview($cnt, id, perfid);
		}
	},

	showPreview: function($cnt, id, perfID)
	{
		this.roomPreview = new window["SxcChatPreview"](document.getElementById(id), {
			apiURL: this.params.apiURL
		});

		this.roomPreview.setVolume(0);

		const that = this;

		this.roomPreview.showRoom(perfID, (mode) =>
		{
			if (mode === "error") {
				this.showStatus(this.currentRoom.container, this.currentRoom.perfid, "offline");
			} else {
				if (mode === "priv" || mode === "exclusive") {
					mode = "private";
				}
				this.showStatus(this.currentRoom.container, this.currentRoom.perfid, mode);
			}

			if (mode === "free") {
				this.redirectTimer = setTimeout(function() {
					if (that.currentRoom && that.currentRoom.url)
						location.href = that.currentRoom.url;
				}, this.redirectTimeout)
			}
		});

		this.addLoadingAnimation();
	},

	removeLoadingAnimation: function () {
		if (this.currentRoom && this.currentRoom.container) {
			this.currentRoom.container.removeClass("loading");
		}
	},

	addLoadingAnimation: function () {
		if (this.currentRoom && this.currentRoom.container) {
			this.currentRoom.container.addClass("loading");
		}
	},

	showStatus: function($cnt, perfid, status) {

		// debug.log("showStatus", perfid, status);

		var text = this.params.translation[status] || status;

		this.removeLoadingAnimation();

		if (status === "free") {
			// Put up status msg
			$cnt.append($("<div class='live-badge'/>").text(text));

		} else {
			// Put up status msg
			$cnt.empty().append($("<div class='online-status'/>").text(text));
		}
	},

	/**
	 * Hide the currently visible preview (if any) and remove the redirect timer
	 */
	hide: function() {

		// debug.log("RoomPreview.hide");

		this.removeLoadingAnimation();

		if (this.currentRoom)
		{
			if (this.roomPreview) {
				this.roomPreview.cancel(() => {
				});
				this.roomPreview = null;
			}

			this.currentRoom.container.empty();
			this.currentRoom = null;
		}

		if (this.redirectTimer) clearTimeout(this.redirectTimer);

		if (!this.enabled) return;

		window["roomList"].enableAjax();
	},

	disable: function() {
		this.hide();
		this.enabled = false;
	},

	enable: function() {
		this.enabled = true;
	}
};

interface ECHH {
	id : number;
	start : number;
	end : number;
	bonus : number;
	startTimer : number;
	endTimer : number;
}

class EcHappyHour
{
	promos : ECHH[] = [];

	handlers : any = {
		start: [],
		end: []
	};

	constructor()
	{
		this.update();
		setInterval(() => this.update(), 5 * 60 * 1000);
	}

	update()
	{
		$.getJSON("/ajax/credit/getechh")
			.then((r) => {
				this.onNewData(r.data);
			});
	}

	onNewData(data : ECHH[])
	{
		const now = Date.now();

		for (let item of data)
		{
			// Do not add if already added
			if (this.getByID(item.id)) continue;

			// Do not add if expired
			if (now > item.end * 1000) continue;

			console.log("trigger", now, item.start * 1000);

			// Fire start handlers if already running, schedule firing if not
			if (now > item.start * 1000) {
				this.trigger("start", item);
				item.startTimer = null;
			} else {
				let cb = ((item) => () => this.trigger("start", item))(item);
				// @ts-ignore
				item.startTimer = setTimeout(cb, (item.start * 1000) - Date.now());
			}

			// Schedule fireing end callbacks
			let cb2 = ((item) => () => this.trigger("end", item))(item);
			// @ts-ignore
			item.endTimer = setTimeout(cb2, (item.end * 1000) - Date.now());

			this.promos.push(item);
		}
	}

	getByID(id : number)
	{
		for (let p of this.promos) {
			if (p.id === id) {
				return p;
			}
		}
		return null;
	}

	getRunningPromo()
	{
		const now = Date.now() / 1000;

		for (let p of this.promos) {
			if (p.start > now && p.end < now) {
				return p;
			}
		}
		return null;
	}

	private trigger(handler : string, item : ECHH)
	{
		console.log("ECHH", "trigger", handler, item);
		for (let callback of this.handlers[handler]) {
			callback(item)
		}
	}

	on(handler : string, callback : Function)
	{
		this.handlers[handler].push(callback);

		if (handler === "start") {
			const running = this.getRunningPromo();
			if (running) {
				callback(running);
			}
		}
	}
}

